import k from '../k'

export const w = k.width()
export const h = k.height()

export const stats = {
  isCharging: false,
  isJumping: false,
  isMovingLeft: false,
  isMovingRight: false,
  durability: 60,
  energy: 60,
  speed: 80,
  parts: 0,
  death: '',
  sleepy: false,
  broken: false,
  finish: false
}

export const platformSpeed = 25
